import AgentProfileEditor from './agent_profile_editor';
import AnswersPreview from './answers_preview';
import ApiTokens from './api_tokens';
import Boot from './boot';
import ChannelsAdmin from './channels_admin';
import CustomerCombine from './customer_combine';
import CustomerView from './customer_view';
import CustomReporting from './custom_reporting';
import ExternalCustomerLookup from './external_customer_lookup';
import ForgotPassword from './forgot_password';
import Floorboard from './floorboard';
import Inbox from './inbox';
import InboxesAdmin from './inboxes_admin';
import Integrations from './integrations';
import IntegrationsLookupApi from './integrations/lookup_api';
import KbAdmin from './kb_admin';
import KeywordGroups from './keyword_groups';
import Liveboards from './liveboards';
import Reports from './reports';
import Search from './search';
import SnippetEditor from './snippet_editor';
import TeamEditor from './team_editor';
import Topics from './topics';
import UserActivation from './user_activation';
import UsersAdmin from './users_admin';
import UserEditor from './user_editor';
import UserLogin from './user_login';
import UserResetPassword from './user_reset_password';
import WebhookEditor from './integrations/webhook_editor';
import WebhooksAdmin from './integrations/webhooks_admin';

let locationClasses = [
  AgentProfileEditor,
  AnswersPreview,
  ApiTokens,
  Boot,
  ChannelsAdmin,
  CustomerCombine,
  CustomerView,
  CustomReporting,
  ExternalCustomerLookup,
  ForgotPassword,
  Floorboard,
  Inbox,
  InboxesAdmin,
  Integrations,
  IntegrationsLookupApi,
  KbAdmin,
  KeywordGroups,
  Liveboards,
  Reports,
  Search,
  SnippetEditor,
  TeamEditor,
  Topics,
  UserActivation,
  UserEditor,
  UserLogin,
  UserResetPassword,
  UsersAdmin,
  WebhookEditor,
  WebhooksAdmin,
];

export default Object.freeze(locationClasses.map(c => [c.typeName, c]));



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/location_classes.js